import * as Reducers from './chime.reducers';

export const ChimeReducers = {
  Reducers,
};
